import { render, staticRenderFns } from "./DummyPlatformOwnofferComponent.vue?vue&type=template&id=0eba9d97&"
import script from "./DummyPlatformOwnofferComponent.vue?vue&type=script&lang=js&"
export * from "./DummyPlatformOwnofferComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports